import apiRequest from '@/js/helpers/apiRequest';
import { buildCollection, buildErrorCollection } from '@/js/utils/processingOpenApi';

/**
 * Получаем список рекомендуемых товаров
 * @param {Object} payload
 * @param {string} payload.recoType - Алгоритм поиска похожих товаров (reco, reco_kk)
 * @param {number} [payload.pageSize=15] - Количество товаров на странице
 * @param {boolean} [payload.isGetAuthors=true] - Нужно ли получить автора товара
 * @param {boolean} [payload.isGetBadge=true] - Нужно ли получить бейджи товара
 * @param {boolean} [payload.isGetSeries=false] - Нужно ли получить серии товара
 * @param {boolean} [payload.isGetProductText=false] - Нужно ли получить описание товара
 * @param {string} [payload.getQuotes=''] - Получить цитаты товаров, строка вида quote:limit(2|0)
 * @param {boolean} [payload.isGetPublishingHouse=false] - Нужно ли получить издателя товара
 * @param {boolean} [payload.isGetCategory=false] - Нужно ли получить категорию товара
 * @param {boolean} [payload.isGetParentCategory=false] - Нужно ли получить родительские категории товара
 * @return {Promise<unknown>}
 */

export default (payload = {}) => new Promise((resolve, reject) => {
  const {
    recoType,
    pageSize = 15,
    isGetAuthors = true,
    isGetBadge = true,
    isGetSeries = false,
    isGetProductText = false,
    isGetPublishingHouse = false,
    isGetCategory = false,
    isGetParentCategory = false,
  } = payload;

  if (!recoType) reject(new Error('[RecommendationService: getRecommendationProduct] параметр recoType обязателен для заполнения'));
  if (typeof recoType !== 'string') reject(new Error('[RecommendationService: getRecommendationProduct] recoType должен быть строкой'));

  const dataRequest = {
    recoType,
    'per-page': pageSize,
  };

  const include = [];
  if (isGetAuthors) include.push('author');
  if (isGetSeries) include.push('series');
  if (isGetBadge) include.push('badge');
  if (isGetProductText) include.push('productText');
  if (isGetPublishingHouse) include.push('publishingHouse');
  if (isGetCategory) include.push('category');
  if (isGetParentCategory) include.push('category.parentCategory');

  if (include.length) dataRequest.include = include.join(',');

  return apiRequest.get('/reco-product/recommendation/', dataRequest)
    .then(({ data: dataRes }) => {
      const { list, pagination } = buildCollection(dataRes, true);
      return resolve({ list, pagination });
    })
    .catch((e) => {
      if (e.response) {
        const errors = buildErrorCollection(e.response.data);
        // знаем точно что ожидаем одну ошибку
        const [firstError] = errors;
        return reject(firstError);
      }
      return reject(e);
    });
});
